import { supabase } from './supabase';

// ── ИГРА «ЛОВИМ ДОЛЮ» ───────────────────────────────────────────────────────
// Настройки хранятся одной строкой в app_settings (key = 'game'):
//   { enabled: boolean, url: 'https://...' }
// Игра живёт на отдельном хостинге; Field Hub только показывает кнопку-ссылку.

const KEY = 'game';

export function isValidGameUrl(url) {
  return /^https:\/\/[^\s]+$/i.test(String(url || '').trim());
}

// Никогда не бросает: если таблицы ещё нет или сеть упала — игра просто скрыта.
export async function getGameSettings() {
  try {
    const { data, error } = await supabase.from('app_settings').select('value, updated_at').eq('key', KEY).maybeSingle();
    if (error) return { enabled: false, url: '', error: error.message };
    const v = data?.value || {};
    return { enabled: !!v.enabled, url: String(v.url || '').trim(), updatedAt: data?.updated_at || null };
  } catch (e) {
    return { enabled: false, url: '', error: String(e?.message || e) };
  }
}

export async function saveGameSettings({ enabled, url }) {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY, value: { enabled: !!enabled, url: String(url || '').trim() }, updated_at: new Date().toISOString() }, { onConflict: 'key' });
  if (error) throw new Error(error.message);
}

// Проверка «прогноз на неделю заполнен».
// Маршруты: в каждый день недели, где заказ > 0, должен стоять прогноз (статус).
//   Вакансии и ПМ не проверяем (как в алёрте ТМ «не проставлено планирование»).
// Гиппера: в каждый день, где заказ по точке > 0, должно стоять планирование.
//   Точки сводятся по ship_to так же, как во вкладке «Гиппера».
export function checkWeekForecast({ routes, orders, statusesV, hyperData, weekDays }) {
  const dates = (weekDays || []).map(d => d.date);
  const routeGaps = [];
  (routes || []).forEach(r => {
    if (r.is_pm || r.is_vacancy) return;
    const miss = dates.filter(dt => (orders?.[r.id]?.[dt]?.visits ?? 0) > 0 && !statusesV?.[r.id]?.[dt]?.code);
    if (miss.length) routeGaps.push({ route: r, dates: miss });
  });

  const hyperGaps = [];
  const points = hyperData?.points || [];
  const daily = hyperData?.daily || {};
  if (points.length) {
    const byShip = {};
    points.forEach(p => {
      const key = String(p.ship_to);
      if (!byShip[key]) byShip[key] = { ship_to: p.ship_to, client: p.client, address: p.address, pointIds: [] };
      byShip[key].pointIds.push(p.id);
      if (p.client && !byShip[key].client) byShip[key].client = p.client;
    });
    Object.values(byShip).forEach(st => {
      const miss = dates.filter(dt => {
        const order = st.pointIds.reduce((s, id) => s + (daily[id]?.[dt]?.order || 0), 0);
        if (order <= 0) return false;
        const planned = st.pointIds.some(id => { const c = daily[id]?.[dt]; return c && (c.plan != null || c.code); });
        return !planned;
      });
      if (miss.length) hyperGaps.push({ store: st, dates: miss });
    });
  }

  const routeDays = routeGaps.reduce((s, g) => s + g.dates.length, 0);
  const hyperDays = hyperGaps.reduce((s, g) => s + g.dates.length, 0);
  return { routeGaps, hyperGaps, routeDays, hyperDays, ok: routeDays === 0 && hyperDays === 0 };
}
